// extracted by mini-css-extract-plugin
module.exports = {"one-col-story-list":"one-col-story-list-module__one-col-story-list__3jl9h"};